

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { EmployeeBankSetup } from "../../components/EmployeeBankSetup/EmployeeBankSetup";


export const EmployeeBankSetupPage = () => {
    return (
        <AuthenticatedLayout
            pageTitle=""
            pageTitleIcon={<DescriptionOutlinedIcon />}
            breadcrumbCurrentPageName=""
            breadcrumbLinks={[
                { text: "", navigateTo: "/employee/bank-setup" }
            ]}
            mainContents={<EmployeeBankSetup />}
        />
    );
};
